import {ConvertorFieldTypeToDataType} from 'src/components/data-types/constants';
import {ArrayFilterPredicate} from 'src/hooks/filtered-data/array-filter-predicate';
import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';
import {StringFilterPredicate} from 'src/hooks/filtered-data/string-filter-predicate';
import {Filters} from 'src/modules/attributes/typedefs';
import {AttributeRelationInfo} from 'src/openapi/models/AttributeRelationInfo';

export const createPredicates = (filters: Filters): FilterPredicate<AttributeRelationInfo>[] => {
    return [
        new StringFilterPredicate((row: AttributeRelationInfo) => row.name, filters.name),
        new ArrayFilterPredicate((row: AttributeRelationInfo) =>
            row.fieldTypes.map(dataType => ConvertorFieldTypeToDataType[dataType]), filters.fieldTypes),
        new ArrayFilterPredicate((row: AttributeRelationInfo) => row.eventCodes, filters.eventCodes),
    ];
};
